import lang from "../assets/i18n/en.json";

export const validatePassword = (value) => {
  const minLength = 12;
  const maxLength = 16;
  const passwordPattern =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-=_+{}[\]:;"'<>,.?/~`|\\/])[a-zA-Z\d!@#$%^&*()\-=_+{}[\]:;"'<>,.?/~`|\\/]{12,}$/;
  let errorStatus = false;
  let errorMessage = "";

  if (value.length > maxLength) {
    errorStatus = true;
    errorMessage = "Password should be in between 12 to 16 characters.";
  } else if (value.length === 0) {
    errorStatus = true;
    errorMessage = "Enter valid password.";
  } else if (value.length < minLength || !passwordPattern.test(value)) {
    errorStatus = true;
    errorMessage =
      "Password should be at least 12 characters long or maximum limit 16 characters with at least 1 uppercase letter, 1 special character and 1 number.";
  }

  return { errorStatus, errorMessage };
};

export const validateConfirmPassword = (
  password,
  value,
  errorMessage = "Passwords should match.",
) => {
  const errorStatus = password !== value;
  return {
    errorStatus,
    errorMessage: errorStatus ? errorMessage : "",
  };
};

export const validateEmail = (
  emailId,
  errors,
  setError,
  validateIncomplete = false,
) => {
  const email = emailId.trim();
  const regex =
    /^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)+$/;
  const whiteSpace =
    /^[A-Za-z0-9!@#$%^&*().,<>{}\[\]<>?_=+\-|;:'"\/]+$/;
  const isCompleteEmail =
    email?.includes("@") || email?.split("@")[1]?.includes(".");

  if (isCompleteEmail || validateIncomplete) {
    if (regex.test(email) && email.match(whiteSpace) && email.length < 500) {
      setError((errors) => ({
        ...errors,
        email: false,
        emailError: "",
      }));
    } else if (email.length > 500) {
      setError((errors) => ({
        ...errors,
        email: true,
        emailError: lang?.PAGE?.AUTH?.SIGNUP?.EMAIL?.MAX_LENGTH,
      }));
    } else {
      setError((errors) => ({
        ...errors,
        email: true,
        emailError: "Must enter a valid work email address.",
      }));
    }
  } else {
    setError((errors) => ({
      ...errors,
      email: true,
      emailError: "",
    }));
  }
};

export const getNameValidationError = (name, value, page) => {
  const fieldValue = typeof value === "string" ? value : "";
  const isFirstName = name === "firstName";

  if (!fieldValue.trim()) {
    return isFirstName
      ? page.AUTH.SIGNUP.FIRSTNAME.VALIDATION_ERROR
      : page.AUTH.SIGNUP.LASTNAME.VALIDATION_ERROR;
  }

  if (!/^[A-Za-z ]+$/.test(fieldValue)) {
    return isFirstName
      ? page.AUTH.SIGNUP.FIRSTNAME.IS_ALPHABET
      : page.AUTH.SIGNUP.LASTNAME.IS_ALPHABET;
  }

  if (fieldValue.length > 50) {
    return isFirstName
      ? page.AUTH.SIGNUP.FIRSTNAME.MAX_LENGTH
      : page.AUTH.SIGNUP.LASTNAME.MAX_LENGTH;
  }

  return "";
};

export const getInstitutionValidationError = (
  value,
  page,
  prioritizeLength = false,
) => {
  const institutionName = typeof value === "string" ? value : "";
  const institutionPattern = /^(?=.*[a-zA-Z0-9])[a-zA-Z0-9_ -]+$/;

  if (!institutionName.trim()) {
    return page.AUTH.SIGNUP.INSTITUTION.IS_REQUIRED;
  }

  if (prioritizeLength && institutionName.length > 50) {
    return page.AUTH.SIGNUP.INSTITUTION.MAX_LENGTH;
  }

  if (!institutionPattern.test(institutionName)) {
    return page.AUTH.SIGNUP.DEPARTMENT.SPECIAL_CHARACTER_NOT_ALLOWED;
  }

  if (institutionName.length > 50) {
    return page.AUTH.SIGNUP.INSTITUTION.MAX_LENGTH;
  }

  return "";
};
